import { defineGameCard, onResolve } from '../authoring/index.js';
import { plannedTarget } from './helpers.js';
export const RedZoneCard = defineGameCard({
    id: 'red_zone',
    gameplay: {
        type: 'SPELL',
        cost: 1,
        planning: {
            target: 'unit', unitFilter: 'ally', uniqueTargetPerRound: true,
            validatePlan(state, _playerId, plan) {
                const target = plan.targetInstanceId === undefined ? undefined : state.instances[plan.targetInstanceId];
                return (target?.heat ?? 0) > 0;
            },
        },
    },
    presentation: {
        name: 'Красная зона',
        description: 'Выбранная перегретая союзная карта получает +2 к атаке. Она получает Перегрев 1.',
        glyph: {
            colors: ['#D21917', '#F84F11', '#10213A', '#FFC277', '#E73811'],
            rows: [
                '....................',
                '.........1..........',
                '..........2.........',
                '....33.3..1..2332...',
                '..2224323.12.3443...',
                '...2243232..33423...',
                '....324432334223....',
                '...32423511533223...',
                '....323522215223....',
                '.....1522225113.12..',
                '....1222222513.11...',
                '...211152555122.1...',
                '..22.3115551223.....',
                '....351115113135....',
                '.....3521332343.....',
                '......312..2232.....',
                '....22..1..11..5....',
                '...5.....2.2....1...',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    abilities: [
        onResolve((ctx) => {
            const targetId = plannedTarget(ctx);
            if (targetId === undefined)
                return;
            ctx.ops.modifyStat(targetId, 'attack', 2, ctx.self.id);
            ctx.ops.addHeat(targetId, 1);
        }),
    ],
    ui: { mechanics: ['heat'] },
});
//# sourceMappingURL=red-zone.js.map